import React from "react";
import $ from "jquery";
import PreviewerIFrame from "../../components/PreviewerIFrame/PreviewerIFrame";
import {
  checkForElement,
  formatSwitch,
  isVideoPlaying,
} from "../../util/creativeUtil";

interface LegacyPreviewerProps {
  buildID: string;
  iframeSrcDoc: string;
  creativeFormat: string;
  sessionSize: number;
  attentionTime: number;
  scriptVersion: string;
  creativeNames: string[];
  brandNames: string[];
  campaignNames: string[];
  scrollMode: string;
  containsVideo: boolean;
  setCreativeScrollProgress: (progress: number) => void;
  setFormatObject: (formatObject: any) => void;
  setIframeVideo: (videoElement: HTMLVideoElement | null) => void;
  setIframeVideoProgress: (progress: number) => void;
}

const LegacyPreviewer: React.FC<LegacyPreviewerProps> = ({
  buildID,
  iframeSrcDoc,
  creativeFormat,
  sessionSize,
  attentionTime,
  scriptVersion,
  creativeNames,
  brandNames,
  campaignNames,
  scrollMode,
  containsVideo,
  setCreativeScrollProgress,
  setFormatObject,
  setIframeVideo,
  setIframeVideoProgress,
}) => {
  const iframeScrollHandler = (e: any) => {
    const seamlessFrame = e.target
      .getElementById("middle-ad")
      .getElementsByTagName("iframe")[0];

    let frameFormat =
      seamlessFrame.contentWindow.xyzContext.dimension.creative.format;
    const format = frameFormat.includes("-")
      ? formatSwitch(
          seamlessFrame.contentWindow.xyzContext.dimension.creative.format
        )
      : frameFormat;

    let progress =
      scrollMode === "timeline"
        ? seamlessFrame.contentWindow[format]
          ? seamlessFrame.contentWindow[format].timeline ||
            seamlessFrame.contentWindow[format].cat.timeline
          : seamlessFrame.contentWindow.format.timeline ||
            seamlessFrame.contentWindow.format.cat.timeline
        : seamlessFrame.contentWindow[format]
        ? seamlessFrame.contentWindow[format].progress
        : seamlessFrame.contentWindow.format.progress;

    setCreativeScrollProgress(progress);
  };

  const iframeOnLoadHandler = async (e: any) => {
    let eTarget = e.target;

    if (!eTarget.contentWindow.document.getElementById("middle-ad")) return;
    const iframeWindow = eTarget.contentWindow;
    if (iframeWindow.length) {
      let targetFrame = iframeWindow.document
        .getElementById("middle-ad")
        .getElementsByTagName("iframe")[0];

      let format =
        targetFrame.contentWindow.xyzContext.dimension.creative.format;
      let camelCaseFormat = format.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
      });
      let formatObject =
        targetFrame.contentWindow[camelCaseFormat] ||
        targetFrame.contentWindow.format;
      setFormatObject(formatObject);
      let foundVideo = false;

      const checkVideoElement = () => {
        if (containsVideo && !foundVideo) {
          let videoElement: HTMLVideoElement | null = null;
          if (formatObject.catVideo || formatObject.video) {
            foundVideo = true;
            switch (format) {
              case "hang-time":
                videoElement =
                  formatObject.catVideo ||
                  formatObject.video ||
                  formatObject.video.container.childNodes[0];
                break;
              case "video-switch":
                videoElement = formatObject.catVideo || formatObject.video;
                videoElement!.loop = true;
                break;
              default:
                videoElement = null;
            }
            setIframeVideo(videoElement);

            if (videoElement) {
              let videoWatcher = setInterval(() => {
                if (isVideoPlaying(videoElement)) {
                  setIframeVideoProgress(
                    (videoElement.currentTime / videoElement.duration) * 100
                  );
                }
              }, 25);
              targetFrame.addEventListener("beforeunload", function () {
                clearInterval(videoWatcher);
              });
            }
          }
        }
      };
      iframeWindow.addEventListener("scroll", (ev: any) => {
        iframeScrollHandler(ev);
        checkVideoElement();
      });

      await checkForElement(iframeWindow, ".xyz-overlay");
      const xyzOverlay =
        iframeWindow.document.body.getElementsByClassName("xyz-overlay")[0];
      const top = xyzOverlay.getBoundingClientRect().top;
      const $target = $(eTarget);
      $target.contents().children().scrollTop(800);
      let scrollDistance = 1750;
      $target.contents().children().animate(
        {
          scrollTop: scrollDistance,
        },
        1500,
        "swing"
      );

      if (containsVideo && !foundVideo && document.hidden) {
        const visibilityHandler = () => {
          if (!document.hidden) {
            checkVideoElement();
            let videoCheckCounter = 0;
            const checkVideoTimer = setInterval(() => {
              checkVideoElement();

              if (foundVideo) {
                document.removeEventListener(
                  "visibilitychange",
                  visibilityHandler
                );
                clearInterval(checkVideoTimer);
              }
              if (videoCheckCounter > 20) {
                document.removeEventListener(
                  "visibilitychange",
                  visibilityHandler
                );
                clearInterval(checkVideoTimer);
              }
              videoCheckCounter++;
            }, 250);
          }
        };

        document.addEventListener("visibilitychange", visibilityHandler);
      }
    }
  };
  return (
    <PreviewerIFrame
      srcDoc={iframeSrcDoc}
      creativeFormat={creativeFormat}
      onLoadHandler={iframeOnLoadHandler}
      creativeID={buildID}
      sessionSize={sessionSize}
      attentionTime={attentionTime}
      scriptVersion={scriptVersion}
      creativeNames={creativeNames}
      brandNames={brandNames}
      campaignNames={campaignNames}
      isLoading={false}
      isLegacy={true}
    />
  );
};

export default LegacyPreviewer;
